<!-- eslint-disable max-len -->
<template>
    <div
        class="mobile-general-form-upload mobile-general-form-multiple-upload"
        :class="`uuid-${config.uuid} ${!!props.required && !globalModel.preview ? 'is-required' : ''} ${globalModel.preview ? 'preview-text' : ''} ${ocrStatus ? 'has-ocr-result' : ''} ${notChanged ? 'disable-opacity' : ''}`"
        v-show="!hideVideoComp"
        ref="uploadRef"
    >
        <form-group :title="i18nLabel" :class="{ 'hide-title': !!props.hideTitle } ">
            <div class="example" @click="onCheckExample" v-if="props.exampleSettings && !globalModel.preview && !globalModel.hideSubmitStyle">
                查看示例
            </div>
            <sub-title class="mt4" v-if="lastShowRejectTip(i18nLabel)" :errorMsg="outputError(i18nLabel)"></sub-title>
            <sub-title :text="props.showTips" :errorMsg="errorMsg" v-if="!globalModel.preview && !globalModel.hideSubmitStyle"></sub-title>
            <div class="upload-content">
                <image-upload
                    v-if="showImageUpload"
                    name="addButton"
                    :style="{ height: imgWidth }"
                    :tip="i18n(props.hint)"
                    :counter="counterText"
                    @select="onAddButtonClick"
                ></image-upload>
                <upload-item
                    v-for="(fileItem, fileIndex) in fileList"
                    v-model="fileList[fileIndex]"
                    :key="fileItem.fileId"
                    :style="{ height: imgWidth }"
                    :class="{'rotate-img': fileItem.rotate }"
                    @upload-success="onUploadSuccess"
                    @upload-preview="onPreviewClick(fileItem)"
                    @retry-select="onAddButtonClick"
                    @upload-clear="onUploadClear"
                ></upload-item>
            </div>
            <ocr-result :ocrStatus="ocrStatus" :desc="ocrDesc"></ocr-result>
        </form-group>
        <input
            class="mobile-general-form-upload__input"
            type="file"
            ref="input"
            :multiple="true"
            :accept="props.accept"
            @change="onInputChange"
        />
        <img-previewer
            ref="imgPreviewerRef"
            :previewList="previewList"
            @on-delete-file="onDeleteFile"
            :noticeFormPreview="globalModel.noticeFormPreview"
        ></img-previewer>
        <picker-panel v-model="panelShow" title="示例图">
            <file-example @confirm="onCheckExample" :exampleData="props.exampleSettings"></file-example>
        </picker-panel>
    </div>
</template>
<script>
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import FormGroup from '@ks/sharp-comp-form-group';
import '@ks/sharp-comp-form-group/lib/themes/default/index.css';
import ImageUpload from '@ks/sharp-comp-image-upload';
import '@ks/sharp-comp-image-upload/lib/themes/default/index.css';
import ComponentBase from '../component-base';
import { component } from './props';
import { base64ToFile } from '../../utils/file';
import UploadItem from './upload-item';
import FileExample from '../component-base/common/file-example';
import { FILE_STATUS } from './config';
import { OCR_STATUS, URL_IMG_OCR } from '../../const';
import EXIF from 'exif-js';
import { composeUrlWithParam } from '../../utils';
import '@ks/sharp-comp-previewer/lib/themes/default/index.css';
import ImgPreviewer from '../component-base/common/img-previewer';
import SubTitle from '../component-base/common/sub-title';
import OcrResult from '../component-base/common/ocr-result.vue';
import PickerPanel from '../component-base/common/picker-panel';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
const videoExtensions = /\.(mp4|mpg|mpeg|mov)$/i;
import { Toast } from '@ks/sharp-ui';
import { $fileUploader } from '../component-base/xhr';
import { canBridgeUse, useBridge } from '../../utils/bridge/common';


export default {
    name: component,
    components: {
        UploadItem,
        FormGroup,
        ImageUpload,
        ImgPreviewer,
        SubTitle,
        PickerPanel,
        FileExample,
        OcrResult,
    },
    extends: ComponentBase,
    provide() {
        return {
            uploadComponent: this, // 给内层组件提供一个使用最外层的入口
        };
    },
    data() {
        return {
            // 组件内部维护一份文件列表
            fileList: [],
            // 验证错误信息
            errorMsg: '',
            // 生成fileId使用
            tempIndex: 1,
            // 预览图
            showPreview: false,
            previewImgSrc: '',
            imgWidth: '90px',
            previewerOptions: {
                loop: false,
                closeEl: false,
                errorMsg: '<div class="pswp__error-msg">图片加载失败，请等待上传完成再预览</div>',
            },
            previewList: [],
            curPreviewIndex: 0,
            showErrorMsg: false,
            panelShow: false,
            isFirst: true, // props.hide首次变化
            ocrStatus: OCR_STATUS.INIT, // 0是初始态
        };
    },
    computed: {
        counterText() {
            if (this.props.max) {
                return `${this.fileList.length} / ${this.props.max}`;
            }
            return '';
        },
        fileValue() {
            return this.fileList.map(item => item.value);
        },
        allSuccess() {
            if (this.fileList.length) {
                return this.fileList.every(item => item.status === FILE_STATUS.success);
            }
            return true;
        },
        isProgressing() {
            if (this.fileList.length) {
                return !!this.fileList.find(item => item.status === FILE_STATUS.progress);
            }
            return false;
        },
        allProcessed() {
            return this.fileList.every(item =>
                item.status === FILE_STATUS.success || item.status === FILE_STATUS.ready
            );
        },
        showImageUpload() {
            // eslint-disable-next-line max-len
            return !this.notChanged && (!this.props.max || this.fileList.length < +this.props.max) && !this.globalModel.preview && !this.globalModel.hideSubmitStyle;
        },
        ocrDesc() {
            let desc = '';
            switch (this.ocrStatus) {
                case OCR_STATUS.FAIL:
                    desc = this.props.ocrFail || '识别失败！请按照提示填写以下内容';
                    break;
                case OCR_STATUS.SUCCESS:
                    desc = this.props.ocrSuccess || '识别成功！请确保识别内容是否与图片信息一致';
                    break;
            }
            return desc || '';
        },
        extraParams() {
            return this.globalModel.globalParams || {
                ...this.$route.params,
                ...this.$route.query,
            };
        },
        logParams() {
            return {
                is_ocr: this.props.isOcr ? 1 : 0,
                item_title: this.i18nLabel,
                item_id: this.props.ocrType || -1,
            };
        },
        hideVideoComp() {
            // 如果hide为true，则隐藏整个组件
            if (this.props.hide) {
                return true;
            }
            // 如果hide为false，正常展示，但是公告表单预览模式下，如果fileList为空，则隐藏整个组件
            console.log('[hal] hideVideoComp', this.globalModel.noticeFormPreview, this.fileList, window.location.href);
            if (this.globalModel.noticeFormPreview && !this.fileList.length) {
                return true;
            }
            return false;
        },
    },
    watch: {
        allSuccess(val) {
            if (val) {
                // console.log('all-success');
                this.$emit('all-success');
                this.updateSelfValue();
            }
        },
        async fileValue(newVal, oldVal) {
            if (newVal.length > oldVal.length) {
                const newFile = newVal.slice(oldVal.length);
                this.previewList = [...this.previewList, ...await this.getPreviewList(newFile)];
            } else {
                this.previewList = await this.getPreviewList(newVal);
            }
        },
        'props.hide': {
            handler(val) {
                // 只执行一次 避免重复计算
                if (!val && this.isFirst) {
                    this.updateImgWidth();
                    this.isFirst = false;
                }
            },
        },
    },
    async mounted() {
        try {
            this.updateImgWidth();
            const params = {
                photo_list: this.fileValue.length ? this.fileValue : -1,
                ...this.logParams,
            };
            !this.globalModel.preview && formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'COLLECT_INFORMATION_UPLOAD_PHOTO_ITEM', params);
            // 检测fileList里面有无异常值
            this.$nextTick(() => {
                const newList = this.fileList.filter(item => {
                    // 过滤空值
                    if (this.isEmptyValue(item.value)) { return false; }
                    // 如果是公告表单预览模式，过滤掉视频文件
                    if (this.globalModel.noticeFormPreview && videoExtensions.test(item.value)) {
                        return false;
                    }
                    return true;
                });
                this.fileList.splice(0, this.fileList.length, ...newList);
                this.updateSelfValue();
            });
        } catch (error) {
            //
        }
    },
    methods: {
        onCheckExample() {
            this.panelShow = !this.panelShow;
        },
        onDeleteFile(index) {
            this.fileList.splice(index, 1);
            this.updateSelfValue();
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CLICK', 'COLLECT_INFORMATION_DELETE_PHOTO', {});
        },
        async getPreviewList(urlList) {
            const params = this.globalModel.globalParams ? {
                ...this.globalModel.globalParams,
                from: this.$route.query.from || this.$route.params.from || '',
            } : {
                ...this.$route.params,
                ...this.$route.query,
            };
            const allReq = urlList.filter(url => !videoExtensions.test(url)).map(item => {
                return new Promise(resolve => {
                    const src = composeUrlWithParam(this.props.previewSrc + '&from={from}&type={type}', {
                        ...params,
                        ...this.globalModel.formData,
                        file: item,
                        type: this.globalModel.viewType || 0,
                    });
                    const image = new Image();
                    image.onload = () => {
                        resolve({
                            src,
                            w: image.width,
                            h: image.height,
                        });
                    };
                    image.onerror = () => {
                        resolve({
                            src,
                            w: 1080,
                            h: 1080,
                        });
                    };
                    image.src = src;
                });
            });
            const res = await Promise.all(allReq);
            return res;
        },
        onPreviewClick(fileItem) {
            if (!this.onClickForm()) {return;}
            if (!this.previewList.length) {return;}
            const index = this.fileList.filter(item => !videoExtensions.test(item.value)).findIndex(item => item.fileId === fileItem.fileId);
            this.$refs.imgPreviewerRef.showIndex(index);
        },
        findFileIndex(fileItem) {
            return this.fileList.findIndex(item => item.fileId === fileItem.fileId);
        },
        onUploadSuccess() {
            this.updateSelfValue();
        },
        onUploadClear(fileItem) {
            const index = this.findFileIndex(fileItem);
            if (index > -1) {
                this.onDeleteFile(index);
            }
        },
        async onOcrIdentify(files = []) {
            const { bizKey = '', from = '' } = this.extraParams;
            // 如果没选ocrType、 bizKey 直接return
            if (!this.props.ocrType || !bizKey) {
                return;
            }
            const url = URL_IMG_OCR.replace('{bizKey}', bizKey);
            const payload = new FormData();
            // 将FileList对象转换为数组
            const fileListArray = Array.from(files);
            fileListArray.forEach(file => {
                payload.append('files', file);
            });
            payload.append('from', from);
            payload.append('type', this.props.ocrType);
            const { data } = await $fileUploader.post(
                url,
                payload
            );
            // 1. 判断result更新识别结果  2. 把识别结果的值传递下去
            this.ocrStatus = data.result === 1 ? OCR_STATUS.SUCCESS : OCR_STATUS.FAIL;
            formEventBus.$emit(FORM_EVENTS_TYPE.OCR_RECOGNITION, { listen: this.config.uuid, ocrResult: { ...data.data } });
        },
        async onAddButtonClick() {
            if (!this.notChanged) {
                // 上报点击
                this.logger('upload-click');
                const accept = this.props.accept;
                const isSelectImageSupport = await canBridgeUse('post', 'selectImage')
                    && accept.includes('image') && !accept.includes('video');
                // 上报点击埋点
                const params = {
                    photo_list: this.fileValue.length ? this.fileValue : -1,
                    ...this.logParams,
                };
                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CLICK', 'COLLECT_INFORMATION_UPLOAD_PHOTO_ITEM', params);
                if (!isSelectImageSupport) {
                    const acceptBoth = accept.includes('video') && accept.includes('image');
                    // accept = 'video/*,image/*'时会被拦截，无法显示系统文件选择界面
                    // 当accept同时有video,image时，重置accept=''，避免被native拦截
                    if (acceptBoth) {
                        this.$refs.input.accept = '';
                    }
                    this.$refs.input.value = null;
                    this.$refs.input.click();
                    return;
                }
                const nameSpaceApi = 'post.selectImage';
                const bridgeParams = {
                    count: this.props.max - this.fileList.length,
                    // 可以指定来源是相册还是相机，默认二者都有
                    sourceType: ['album', 'camera'],
                    // 字节单位，不存在则为不限制，原图超过该值时自动压缩
                    maxFileSize: this.props.maxSize ? this.props.maxSize * 1024 : 20 * 1024 * 1024,
                    // 像素单位，不存在则为不限制，原图超过该值时自动压缩，建议设置，否则图太大
                    maxWidth: 8640,
                    // 像素单位，不存在则为不限制，原图超过该值时自动压缩，建议设置，否则图太大
                    maxHeight: 8640,
                    // success: ret => {
                    //     setTimeout(() => {
                    //         ret.data.forEach(item => {
                    //             const file = base64ToFile(item);
                    //             this.onFileSelect([file]);
                    //         });
                    //     }, 0);
                    // },
                    // fail: err => {
                    //     setTimeout(() => {
                    //         console.log('fail:' + JSON.stringify(err));
                    //         formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CUSTOM', 'SELECT_FILE_FAILED', {
                    //             error_msg: JSON.stringify(err),
                    //         });
                    //     }, 0);
                    // },
                };
                await useBridge(nameSpaceApi, bridgeParams, res => {
                    setTimeout(() => {
                        if (res.result === 1) {
                            res.data.forEach(item => {
                                const file = base64ToFile(item);
                                this.onFileSelect([file]);
                            });
                        } else {
                            console.log('fail:' + JSON.stringify(res));
                            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CUSTOM', 'SELECT_FILE_FAILED', {
                                error_msg: JSON.stringify(res),
                            });
                        }
                    }, 0);
                });
            }
        },
        onInputChange(ev) {
            const files = ev.target.files;
            if (!files || !files.length) {
                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CUSTOM', 'SELECT_FILE_FAILED', {
                    error_msg: 'file empty',
                });
                return;
            }
            const accept = this.props.accept;
            // 格式无限制时，不校验格式
            if (!accept || accept === '*') {
                this.onFileSelect(files);
                return;
            }
            // 对选择结果进行格式校验
            const filteredFiles = Array.from(files).filter(file => {
                const type = file.type.split('/');
                if (accept.includes(type[0]) && file.type) {
                    return true;
                }
                const msg = type[1] ? type[1] : '该';
                Toast.error(`不支持上传${msg}格式的文件`);
                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CUSTOM', 'SELECT_FILE_FAILED', {
                    error_msg: `file type error: type=${file.type} accept=${accept}`,
                });
                return false;
            });
            this.onFileSelect(filteredFiles);
        },
        async onFileSelect(files) {
            if (this.props.max && this.fileList.length + files.length > +this.props.max) {
                this.validateFailureHandler(this.i18n(this.props.errMax, this.i18nLabel, this.props.max)
                    || `${this.i18nLabel}不得大于${this.props.max}项`);
                return;
            }
            const postFiles = Array.prototype.slice.call(files);
            this.fileList.push(
                ...postFiles.map((file, index) => ({
                    fileId: Date.now() + this.tempIndex++,
                    status: this.props.autoUpload ? FILE_STATUS.ready : FILE_STATUS.success,
                    value: file,
                }))
            );
            this.props.isOcr && this.onOcrIdentify(files);
        },
        async getRotates(files) {
            const res = [];
            for (let i = 0; i < files.length; i++) {
                const realFile = await new Promise((res, rej) => {
                    EXIF.getData(files[i], function () {
                        const orientation = EXIF.getTag(this, 'Orientation');
                        const isRotate = orientation === 6;
                        if (isRotate) {
                            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CUSTOM', 'SELECT_FILE_ROTATE');
                            const reader = new FileReader();
                            reader.onload = function (e) {
                                const base64data = e.target.result;
                                const img = new Image();
                                img.onload = function () {
                                    const canvas = document.createElement('canvas');
                                    canvas.width = img.width;
                                    canvas.height = img.height;
                                    const ctx = canvas.getContext('2d');
                                    canvas.width = img.height;
                                    canvas.height = img.width;
                                    ctx.rotate(90 * Math.PI / 180);
                                    ctx.drawImage(img, 0, -img.height, img.width, img.height);
                                    // 将图像重新绘制到Canvas上，然后将Canvas内容转换为新的Base64编码
                                    const newBase64 = canvas.toDataURL('image/jpeg');
                                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                                    canvas.parentNode && canvas.parentNode.removeChild(canvas);
                                    // 回调函数，传递新的Base64编码
                                    res(base64ToFile({ base64: newBase64.split(',')[1], fileType: 'jpeg' }));
                                };
                                img.src = base64data;
                            };
                            // 以DataURL形式读取文件内容
                            reader.readAsDataURL(files[i]);
                        } else {
                            res(files[i]);
                        }
                    });
                });
                res[i] = realFile;
            }
            return res;
        },
        updateSelfValue() {
            this.setSelfFormDataValue(cloneDeep(this.fileValue)) && this.$emit('change');
        },
        // 判断是否满足自身条件
        validateSelf() {
            if (!this.allSuccess) {
                this.errorMsg = this.i18n(this.props.errUpload, this.i18nLabel) || `请检查${this.i18nLabel}`;
                return false;
            }
            if ((!this.fileList || !this.fileList.length) && this.props.required) {
                this.errorMsg = this.i18n(this.props.errRequired, this.i18nLabel) || `必须上传${this.i18nLabel}`;
                return false;
            }
            if (this.props.min && this.fileList.length < +this.props.min) {
                this.errorMsg = this.i18n(this.props.errMin, this.i18nLabel, this.props.min)
                    || `${this.i18nLabel}不得少于${this.props.min}项`;
                return false;
            }
            if (this.props.max && this.fileList.length > +this.props.max) {
                this.errorMsg = this.i18n(this.props.errMax, this.i18nLabel, this.props.max)
                    || `${this.i18nLabel}不得大于${this.props.max}项`;
                return false;
            }
            this.errorMsg = '';
            return true;
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            if (!this.allSuccess) {
                // 如果还有文件不处于成功态则跳过处理，否则某些处理中的文件可能被丢弃
                return;
            }
            const newValue = this.getSelfFormDataValue();
            if (!Array.isArray(newValue)) {
                // 需要初始化，默认值空数组
                this.fileList = [];
                this.setSelfFormDataValue(this.fileValue);
                return;
            }

            if (!isEqual(this.fileValue, newValue)) {
                let changed = false;
                for (const itemIndex in newValue) {
                    if (!this.fileList[itemIndex]) {
                        changed = true;
                        this.fileList.push({
                            // 模仿elementUI 上传组件给每个文件添加id
                            fileId: Date.now() + this.tempIndex++,
                            // 被动修改默认是已经上传好的
                            status: FILE_STATUS.success,
                            value: cloneDeep(newValue[itemIndex]),
                        });
                    } else if (
                        typeof this.fileList[itemIndex].value === 'string'
                        && typeof newValue[itemIndex] === 'string'
                        && this.fileList[itemIndex].value !== typeof newValue[itemIndex]) {
                        changed = true;
                        // 只有自身数据和全局数据同时为字符串类型且不相等时才允许修改
                        this.fileList[itemIndex].status = FILE_STATUS.success;
                        this.fileList[itemIndex].value = newValue[itemIndex];
                    }
                }
                // 长度统一
                while (this.fileList.length > newValue.length) {
                    changed = true;
                    this.fileList.pop();
                }

                // 数据被动修改同样抛出change事件
                changed && this.$emit('change');
                // this.validateSelf();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            const res = this.validateSelf();
            this.showErrorMsg = !res;
            if (!res) {
                this.validateFailureHandler(this.errorMsg);
            }
            return res;
        },
        clearValidate() {
            this.errorMsg = '';
            this.showErrorMsg = false;
        },
        async updateImgWidth() {
            await this.$nextTick();
            await new Promise(resolve => setTimeout(resolve, 100));
            try {
                const el = this.$refs.uploadRef.querySelector('.spc-image-upload');
                let clientWidth = el.clientWidth || 90;
                if (clientWidth < 50) {
                    clientWidth = 90;
                }
                this.imgWidth = `${clientWidth || 90}px`;
            } catch (error) {
                //
            }
        },
        isEmptyValue(value) {
            if (typeof value === 'object' && value !== null) {
                return Object.keys(value).length === 0; // 检查空对象
            }
            if (typeof value === 'string') {
                return value.trim() === '' || value === '{}'; // 检查空字符串和字符串 "{}"
            }
            return !value; // 检查 null、undefined 和其他假值
        },
    },
};
</script>
<style lang="less" scoped>
@import '../../style.less';
.is-required {
    /deep/ .spc-form-group h2:after {
        content: '*';
        color: #ff4a4a;
        font-size: inherit;
        line-height: inherit;
    }
}

.mobile-general-form-upload {
    .example {
        position: absolute;
        right: 19px;
        top: 16px;
        color: #326BFB;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }
    .mt4 {
        margin-top: 4px;
    }
    /deep/ .sp-form-item__error {
        top: auto !important;
        right: auto !important;
    }
    /deep/ .spc-form-group h2 {
        padding: 0 0 0 0 !important;
        max-width: calc(100% - 70px);
    }
    .preview-bar {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        z-index: 2000;
        padding: 5px 19px 2px 11px;
        box-sizing: border-box;
        .close {
            width: 40px;
            height: 40px;
            background-image: url('../../../assets/images/back.svg');
        }
        .delete {
            width: 24px;
            height: 24px;
            background-image: url('../../../assets/images/delete.svg');
        }
        .page {
            color: #FFF;
            font-size: 16px;
            line-height: 24px;
        }
    }

    &__input {
        display: none;
    }

    .counter-text {
        position: absolute;
        right: 16px;
        top: 16px;
        color: #9c9c9c;
        font-size: 15px;
        font-weight: 400;
    }

    .spc-form-group {
        position: relative;
        .upload-tips {
            color: #9C9C9C;
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            margin-bottom: 12px;
        }
        /deep/ .content {
            // display: flex;
            // flex-flow: row wrap;
            margin: 0 16px;
        }
        /deep/ .upload-content {
            display: flex;
            flex-flow: row wrap;
        }
    }

    .spc-image-upload {
        width: calc(25% - 6px);
        min-height: 84px;
        // aspect-ratio: 1 / 1;

        /deep/ .box {
            width: 100%;
            height: auto!important;
            .add {
                margin-bottom: 1px;
                width: 24px;
                height: 24px;
                background: var(--csc-collect-spc-image-upload-add) no-repeat 50%;
                background-size: 100% 100%;
            }
            .tip {
                margin-top: 1px;
                line-height: 17px;
                padding: 0 8px;
                color: #9C9C9C;
            }
        }
    }
    .upload-content {
        margin-top: 12px;
        .rotate-img {
            /deep/ .box {
                transform: rotate(90deg) !important;
                .mask {
                    transform: rotate(-90deg) !important;
                }
                .remove {
                    left: 0;
                    right: initial;
                    transform: rotate(90deg) !important;
                }
            }
        }
    }
}

.has-ocr-result {
    /deep/ .spc-form-group {
        padding-bottom: 0 !important;
        margin-bottom: -6px;
    }
    /deep/ .ocr-result {
        margin-top: 4px;
    }
    /deep/ .content {
        overflow-y: hidden;
    }
}
</style>
